import Tile from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import MapElement from "./MapElement";

import { VectorTile } from 'ol/layer';
import { VectorTile as VectorTileSource } from 'ol/source';
import MVT from 'ol/format/MVT';



export default class MapSatellite extends MapElement {
    constructor(map, id, mapElementSettings, parent) {
        super(map, id, mapElementSettings, parent);


        this.appId = '7Usd5XF5XKQBapQI5yTT';
        this.appCode = 'hlt-UrxPKMJltMow9Ry7Pw';

        this.appId = '1yVd6spOWZKGuPr8bV4h';
        this.appCode = 'cYpM8EptNIqgsrb68B5SQlnbNVxwbIFd60HIFqtGDqY'; //API Key

        //this.apiKey = "AAPK40a421ede2604f85bff9b1d2f06a59dcW5g3qQ8d7suz-VyjjgNwvAA4hc_oVQaTN_OCRu69oarquxDDZijdaWFweHO0LfcW";


        this.url = 'https://vector.hereapi.com/v2/vectortiles/base/mc/{z}/{x}/{y}/png?apikey=' + this.appCode

        this.url = `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png?apikey=${this.appCode}`

        this.url = 'https://{1-4}.aerial.maps.cit.api.here.com' +
            '/maptile/2.1/maptile/newest/hybrid.day/{z}/{x}/{y}/256/png' +
            '?apikey=' + this.appCode


        this.url = `https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}`


        /**
         * https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/tilemap/{z}/{y}/{x}/32/32?f=json
         * implement this url to check if data is available at a certain zoom lvl
         * 
         * 
         * 
         */

        
        this.drawLayer();
    }




    drawLayer() {
        // fetch('https://www.arcgis.com/sharing/rest/content/items/30d6b8271e1849cd9c3042060001f425/resources/styles/root.json')
        //     .then(response => response.json())
        //     .then((styleJson) => {

        //         this.layer = new VectorTile({
        //             title: 'Vector Tile Layer',
        //             visible: false,
        //             preload: false,
        //             switchable: true,
        //             source: new VectorTileSource({
        //                 url: "https://basemaps.arcgis.com/arcgis/rest/services/World_Basemap_v2/VectorTileServer/tile/{z}/{y}/{x}",
        //                 format: new MVT()
        //             }),
        //         });


        //         applyStyle(this.layer, styleJson,
        //             {
        //                 transformRequest(url, type) {
        //                     if (type === 'Sprite') {
        //                         return new Request(['https://cdn.arcgis.com/sharing/rest/content/items/30d6b8271e1849cd9c3042060001f425/resources/sprites/sprite.json'])
        //                     }
        //                 }
        //             }
        //         )

        //         // Add the VectorTile layer to the map

        //         this.mapModel.map.addLayer(this.layer);
        //         if (!this.mapElementSettings.defaultOn) {
        //             this.hide();
        //         }
        //     });


        this.layer =
            new Tile({
                title: 'Satellietkaart',
                visible: false,
                preload: false,
                switchable: true, 
                source: new XYZ({
                    url: this.url,
                    maxZoom: 21 
                })
            })
        this.mapModel.map.addLayer(this.layer);
        if (!this.mapElementSettings.defaultOn) {
            this.hide();
        }



    }
}